import React from 'react'
import Carousel from 'react-multi-carousel'
import BlogCard from './BlogCard';

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

export default function BlogCarousel({blogs, authorDetailsNeeded, handleShareToast, deleteButtonNeeded, handleDelete}) {
    return(
        <>
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          ssr={true}
          infinite={false}
          keyBoardControl={true}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >{blogs && blogs.map((blog) => (
           <BlogCard 
           key={blog.blogId} 
           blog={blog} 
           authorDetailsNeeded={authorDetailsNeeded} 
           handleShareToast={handleShareToast}
           deleteButtonNeeded={deleteButtonNeeded}
           handleDelete={handleDelete}
           />
          ))}
          </Carousel>
        </>
    )
}